/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateRiskPolicyRequestBody,
  CreateRiskPolicyRequestBody$Outbound,
  CreateRiskPolicyRequestBody$outboundSchema,
} from "../components/createriskpolicyrequestbody.js";

export type CreateRiskPolicySecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateRiskPolicySecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateRiskPolicySecurity = {
  option1?: CreateRiskPolicySecurityOption1 | undefined;
  option2?: CreateRiskPolicySecurityOption2 | undefined;
};

export type CreateRiskPolicyRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createRiskPolicyRequestBody: CreateRiskPolicyRequestBody;
};

/** @internal */
export type CreateRiskPolicySecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateRiskPolicySecurityOption1$outboundSchema: z.ZodMiniType<
  CreateRiskPolicySecurityOption1$Outbound,
  CreateRiskPolicySecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function createRiskPolicySecurityOption1ToJSON(
  createRiskPolicySecurityOption1: CreateRiskPolicySecurityOption1,
): string {
  return JSON.stringify(
    CreateRiskPolicySecurityOption1$outboundSchema.parse(
      createRiskPolicySecurityOption1,
    ),
  );
}

/** @internal */
export type CreateRiskPolicySecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateRiskPolicySecurityOption2$outboundSchema: z.ZodMiniType<
  CreateRiskPolicySecurityOption2$Outbound,
  CreateRiskPolicySecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createRiskPolicySecurityOption2ToJSON(
  createRiskPolicySecurityOption2: CreateRiskPolicySecurityOption2,
): string {
  return JSON.stringify(
    CreateRiskPolicySecurityOption2$outboundSchema.parse(
      createRiskPolicySecurityOption2,
    ),
  );
}

/** @internal */
export type CreateRiskPolicySecurity$Outbound = {
  Option1?: CreateRiskPolicySecurityOption1$Outbound | undefined;
  Option2?: CreateRiskPolicySecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateRiskPolicySecurity$outboundSchema: z.ZodMiniType<
  CreateRiskPolicySecurity$Outbound,
  CreateRiskPolicySecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CreateRiskPolicySecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CreateRiskPolicySecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function createRiskPolicySecurityToJSON(
  createRiskPolicySecurity: CreateRiskPolicySecurity,
): string {
  return JSON.stringify(
    CreateRiskPolicySecurity$outboundSchema.parse(createRiskPolicySecurity),
  );
}

/** @internal */
export type CreateRiskPolicyRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateRiskPolicyRequestBody: CreateRiskPolicyRequestBody$Outbound;
};

/** @internal */
export const CreateRiskPolicyRequest$outboundSchema: z.ZodMiniType<
  CreateRiskPolicyRequest$Outbound,
  CreateRiskPolicyRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createRiskPolicyRequestBody: CreateRiskPolicyRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      createRiskPolicyRequestBody: "CreateRiskPolicyRequestBody",
    });
  }),
);

export function createRiskPolicyRequestToJSON(
  createRiskPolicyRequest: CreateRiskPolicyRequest,
): string {
  return JSON.stringify(
    CreateRiskPolicyRequest$outboundSchema.parse(createRiskPolicyRequest),
  );
}
